import { NgModule, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  provideHttpClient,
  withInterceptorsFromDi
} from "@angular/common/http";
import { MetaReducer, StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { storeFreeze } from "ngrx-store-freeze";
import { TranslateModule } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

import { debug } from "./meta-reducers/debug.reducer";
import { initStateFromLocalStorage } from "./meta-reducers/init-state-from-local-storage.reducer";
import { LocalStorageService } from "./local-storage/local-storage.service";
import { authReducer } from "./auth/auth.reducer";
import { AuthEffects } from "./auth/auth.effects";
import { AuthGuardService } from "./auth/auth-guard.service";
import { AnimationsService } from "./animations/animations.service";
import { TitleService } from "./title/title.service";
import { environment } from "@env/environment";
import { scheduleReducer } from "@app/core/schedule/schedule.reducer";
import { ScheduleEffects } from "@app/core/schedule/schedule.effects";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { AdminGuardService } from "@app/core/auth/admin-guard.service";
import { TelemetryProviderService } from "@app/core/telemetry/telemetry-provider.service";

export const metaReducers: MetaReducer<any>[] = [initStateFromLocalStorage];

if (!environment.production) {
  metaReducers.unshift(storeFreeze);
  if (!environment.test) {
    metaReducers.unshift(debug);
  }
}

@NgModule({
  exports: [TranslateModule],
  imports: [
    // angular
    CommonModule,
    // ngrx
    StoreModule.forRoot(
      {
        auth: authReducer,
        schedule: scheduleReducer
      },
      { metaReducers }
    ),
    EffectsModule.forRoot([AuthEffects, ScheduleEffects]),
    // 3rd party
    TranslateModule.forRoot()
  ],
  providers: [
    LocalStorageService,
    AuthGuardService,
    AdminGuardService,
    AnimationsService,
    TitleService,
    ClientConfigService,
    TelemetryProviderService,
    provideTranslateHttpLoader({
      prefix: `${environment.i18nPrefix}/assets/i18n/`,
      suffix: ".json"
    }),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error("CoreModule is already loaded. Import only in AppModule");
    }
  }
}
